

import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPrint, FaChevronLeft, FaChevronRight, FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function LiquidacionesTable() {
  const [liquidaciones, setLiquidaciones] = useState([]);
  const [filteredLiquidaciones, setFilteredLiquidaciones] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [searchTercero, setSearchTercero] = useState('');
  const [terceros, setTerceros] = useState([]);
  const [filteredTerceros, setFilteredTerceros] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedTercero, setSelectedTercero] = useState(null);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchLiquidaciones();
    fetchTerceros();
  }, []);

  useEffect(() => {
    filterLiquidaciones();
  }, [searchTerm, searchTercero,startDate,endDate,liquidaciones]);


  useEffect(() => {
    setFilteredTerceros(
      terceros.filter(tercero =>
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )
    );
  }, [searchTercero, terceros]);
  

  const fetchLiquidaciones = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/liquidaciones');
      setLiquidaciones(response.data);
    } catch (err) {
      setError('Error al cargar las liquidaciones. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTerceros = async () => {
    try {
      const response = await axios.get('/terceros');
      setTerceros(response.data);
    } catch (err) {
      setError('Error al cargar los terceros.');
    }
  };

  const filterLiquidaciones = () => {
    let filtered = liquidaciones.filter(liq =>
      liq.concepto.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (liq.terceroId.toLowerCase().includes(searchTercero.toLowerCase()) ||
      terceros.some(tercero =>
        tercero.documento === liq.terceroId &&
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )) &&
      (!startDate || new Date(liq.fecha) >= new Date(startDate)) &&
      (!endDate || new Date(liq.fecha) <= new Date(endDate))
    );
    setFilteredLiquidaciones(filtered);
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar esta liquidación?')) {
      setIsLoading(true);
      try {
        await axios.delete(`/liquidaciones/${id}`);
        fetchLiquidaciones();
      } catch (err) {
        setError('Error al eliminar la liquidación. Intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handlePrint = async (id) => {
    try {
      const response = await axios.get(`/liquidaciones/${id}/pdfliquidacion`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Liquidacion_${id}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      alert('Error al generar el PDF de la liquidación.');
    }
  };

  const totalPages = Math.ceil(filteredLiquidaciones.length / itemsPerPage);
  const currentItems = filteredLiquidaciones.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-4 text-center">Gestión de Liquidaciones</h1>
      <div className="flex justify-between mb-4">
        <div className="flex space-x-4 w-full">
    
    <input
      type="text"
      placeholder="Buscar por Tercero documento..."
      value={searchTercero}
      onChange={(e) => setSearchTercero(e.target.value)}
      className="border p-2 w-full text-sm"
    />
    {filteredTerceros.length > 0 && searchTercero && (
      <div className="absolute z-10 w-full bg-white border border-gray-300 max-h-40 overflow-y-auto shadow-md">
        {filteredTerceros.map((tercero) => (
          <div
            key={tercero.documento}
            className="p-2 cursor-pointer hover:bg-gray-200"
            onClick={() => {
              setSelectedTercero(tercero); // Guardar el tercero seleccionado
              setSearchTercero(tercero.documento); // Opcional: Llenar el input con el documento
            }}
          >
            {tercero.nombre} - {tercero.documento}
          </div>
        ))}
      </div>
    )}

    {selectedTercero && (
      <div className="border p-2 mt-2 bg-gray-100">
        <p><strong>Nombre:</strong> {selectedTercero.nombre}</p>
        <p><strong>Documento:</strong> {selectedTercero.documento}</p>
      </div>
    )}

         <input
            type="text"
            placeholder="Buscar por concepto"
            className="border p-2 rounded w-1/3"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />



          {/*}
          <input
            type="text"
            placeholder="Buscar por Tercero"
            className="border p-2 rounded w-1/3"
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
          />
          <select
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
            className="border p-2 rounded w-1/3"
          >
            <option value="">Seleccione un tercero</option>
            {filteredTerceros.map(tercero => (
              <option key={tercero.documento} value={tercero.documento}>
                {tercero.nombre} - {tercero.documento}
              </option>
            ))}
          </select>
          */}

        </div>
        <Link to="/home/liquidaciones/add" className="bg-green-500 text-white px-4 py-2 rounded flex items-center">
          <FaPlus className="mr-2" /> Añadir Liquidación
        </Link>
      </div>

      <div className="flex space-x-4 w-full">
          <input
            type="date"
            className="border p-2 rounded w-1/5"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <input
            type="date"
            className="border p-2 rounded w-1/5"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>

      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-4">
        <table className="w-full">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-6 py-3">ID</th>
              <th className="px-6 py-3">Fecha</th>
              <th className="px-6 py-3">Tercero ID</th>
              <th className="px-6 py-3">Concepto</th>
              <th className="px-6 py-3">Importe</th>
              <th className="px-6 py-3">Observaciones</th>
              <th className="px-6 py-3">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((liq) => (
              <tr key={liq.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">{liq.id}</td>
                <td className="px-6 py-4">{liq.fecha}</td>
                <td className="px-6 py-4">{liq.terceroId}</td>
                <td className="px-6 py-4">{liq.concepto}</td>
                <td className="px-6 py-4">{liq.importe} €</td>
                <td className="px-6 py-4">{liq.observaciones}</td>
                <td className="px-6 py-4 flex space-x-2">
                  <Link to={`/home/liquidaciones/${liq.id}`} className="text-blue-600 hover:text-blue-900"><FaEye /></Link>
                  <Link to={`/home/liquidaciones/edit/${liq.id}`} className="text-green-600 hover:text-green-900"><FaEdit /></Link>
                  <button onClick={() => handlePrint(liq.id)} className="text-gray-600 hover:text-gray-900"><FaPrint /></button>
                  <button onClick={() => handleDelete(liq.id)} className="text-red-600 hover:text-red-900"><FaTrash /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex justify-center items-center mt-4 space-x-2">
        {[...Array(totalPages).keys()].map(number => (
          <button 
            key={number + 1}
            onClick={() => setCurrentPage(number + 1)}
            className={`px-4 py-2 rounded ${currentPage === number + 1 ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
          >
            {number + 1}
          </button>
        ))}
      </div>
      </div>
    </div>
  );
}


/*
import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPrint, FaChevronLeft, FaChevronRight, FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function LiquidacionesTable() {
  const [liquidaciones, setLiquidaciones] = useState([]);
  const [filteredLiquidaciones, setFilteredLiquidaciones] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [searchTercero, setSearchTercero] = useState('');
  const [terceros, setTerceros] = useState([]);
  const [filteredTerceros, setFilteredTerceros] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchLiquidaciones();
    fetchTerceros();
  }, []);

  useEffect(() => {
    filterLiquidaciones();
  }, [searchTerm, searchTercero,startDate,endDate,liquidaciones]);


  useEffect(() => {
    setFilteredTerceros(
      terceros.filter(tercero =>
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )
    );
  }, [searchTercero, terceros]);
  

  const fetchLiquidaciones = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/liquidaciones');
      setLiquidaciones(response.data);
    } catch (err) {
      setError('Error al cargar las liquidaciones. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTerceros = async () => {
    try {
      const response = await axios.get('/terceros');
      setTerceros(response.data);
    } catch (err) {
      setError('Error al cargar los terceros.');
    }
  };

  const filterLiquidaciones = () => {
    let filtered = liquidaciones.filter(liq =>
      liq.concepto.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (liq.terceroId.toLowerCase().includes(searchTercero.toLowerCase()) ||
      terceros.some(tercero =>
        tercero.documento === liq.terceroId &&
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )) &&
      (!startDate || new Date(liq.fecha) >= new Date(startDate)) &&
      (!endDate || new Date(liq.fecha) <= new Date(endDate))
    );
    setFilteredLiquidaciones(filtered);
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar esta liquidación?')) {
      setIsLoading(true);
      try {
        await axios.delete(`/liquidaciones/${id}`);
        fetchLiquidaciones();
      } catch (err) {
        setError('Error al eliminar la liquidación. Intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handlePrint = async (id) => {
    try {
      const response = await axios.get(`/liquidaciones/${id}/pdfliquidacion`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Liquidacion_${id}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      alert('Error al generar el PDF de la liquidación.');
    }
  };

  const totalPages = Math.ceil(filteredLiquidaciones.length / itemsPerPage);
  const currentItems = filteredLiquidaciones.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-4 text-center">Gestión de Liquidaciones</h1>
      <div className="flex justify-between mb-4">
        <div className="flex space-x-4 w-full">
          <input
            type="text"
            placeholder="Buscar por concepto"
            className="border p-2 rounded w-1/3"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <input
            type="text"
            placeholder="Buscar por Tercero"
            className="border p-2 rounded w-1/3"
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
          />
          <select
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
            className="border p-2 rounded w-1/3"
          >
            <option value="">Seleccione un tercero</option>
            {filteredTerceros.map(tercero => (
              <option key={tercero.documento} value={tercero.documento}>
                {tercero.nombre} - {tercero.documento}
              </option>
            ))}
          </select>
        </div>
        <Link to="/home/liquidaciones/add" className="bg-green-500 text-white px-4 py-2 rounded flex items-center">
          <FaPlus className="mr-2" /> Añadir Liquidación
        </Link>
      </div>

      <div className="flex space-x-4 w-full">
          <input
            type="date"
            className="border p-2 rounded w-1/5"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <input
            type="date"
            className="border p-2 rounded w-1/5"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>

      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-4">
        <table className="w-full">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-6 py-3">ID</th>
              <th className="px-6 py-3">Fecha</th>
              <th className="px-6 py-3">Tercero ID</th>
              <th className="px-6 py-3">Concepto</th>
              <th className="px-6 py-3">Importe</th>
              <th className="px-6 py-3">Observaciones</th>
              <th className="px-6 py-3">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((liq) => (
              <tr key={liq.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">{liq.id}</td>
                <td className="px-6 py-4">{liq.fecha}</td>
                <td className="px-6 py-4">{liq.terceroId}</td>
                <td className="px-6 py-4">{liq.concepto}</td>
                <td className="px-6 py-4">{liq.importe} €</td>
                <td className="px-6 py-4">{liq.observaciones}</td>
                <td className="px-6 py-4 flex space-x-2">
                  <Link to={`/home/liquidaciones/${liq.id}`} className="text-blue-600 hover:text-blue-900"><FaEye /></Link>
                  <Link to={`/home/liquidaciones/edit/${liq.id}`} className="text-green-600 hover:text-green-900"><FaEdit /></Link>
                  <button onClick={() => handlePrint(liq.id)} className="text-gray-600 hover:text-gray-900"><FaPrint /></button>
                  <button onClick={() => handleDelete(liq.id)} className="text-red-600 hover:text-red-900"><FaTrash /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex justify-center items-center mt-4 space-x-2">
        {[...Array(totalPages).keys()].map(number => (
          <button 
            key={number + 1}
            onClick={() => setCurrentPage(number + 1)}
            className={`px-4 py-2 rounded ${currentPage === number + 1 ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
          >
            {number + 1}
          </button>
        ))}
      </div>
      </div>
    </div>
  );
}
*/


/* CORRECTO CON VENTANA DE TERCEROS  
import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPrint, FaChevronLeft, FaChevronRight, FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function LiquidacionesTable() {
  const [liquidaciones, setLiquidaciones] = useState([]);
  const [filteredLiquidaciones, setFilteredLiquidaciones] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchTercero, setSearchTercero] = useState('');
  const [terceros, setTerceros] = useState([]);
  const [filteredTerceros, setFilteredTerceros] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchLiquidaciones();
    fetchTerceros();
  }, []);

  useEffect(() => {
    filterLiquidaciones();
  }, [searchTerm, searchTercero, liquidaciones]);


  useEffect(() => {
    setFilteredTerceros(
      terceros.filter(tercero =>
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      )
    );
  }, [searchTercero, terceros]);
  

  const fetchLiquidaciones = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/liquidaciones');
      setLiquidaciones(response.data);
    } catch (err) {
      setError('Error al cargar las liquidaciones. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTerceros = async () => {
    try {
      const response = await axios.get('/terceros');
      setTerceros(response.data);
    } catch (err) {
      setError('Error al cargar los terceros.');
    }
  };

  const filterLiquidaciones = () => {
    let filtered = liquidaciones.filter(liq =>
      liq.concepto.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (liq.terceroId.toLowerCase().includes(searchTercero.toLowerCase()) ||
      terceros.some(tercero =>
        tercero.documento === liq.terceroId &&
        tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase())
      ))
    );
    setFilteredLiquidaciones(filtered);
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar esta liquidación?')) {
      setIsLoading(true);
      try {
        await axios.delete(`/liquidaciones/${id}`);
        fetchLiquidaciones();
      } catch (err) {
        setError('Error al eliminar la liquidación. Intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handlePrint = async (id) => {
    try {
      const response = await axios.get(`/liquidaciones/${id}/pdfliquidacion`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Liquidacion_${id}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      alert('Error al generar el PDF de la liquidación.');
    }
  };

  const totalPages = Math.ceil(filteredLiquidaciones.length / itemsPerPage);
  const currentItems = filteredLiquidaciones.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-4 text-center">Gestión de Liquidaciones</h1>
      <div className="flex justify-between mb-4">
        <div className="flex space-x-4 w-full">
          <input
            type="text"
            placeholder="Buscar por concepto"
            className="border p-2 rounded w-1/3"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <input
            type="text"
            placeholder="Buscar por Tercero"
            className="border p-2 rounded w-1/3"
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
          />
          <select
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
            className="border p-2 rounded w-1/3"
          >
            <option value="">Seleccione un tercero</option>
            {filteredTerceros.map(tercero => (
              <option key={tercero.documento} value={tercero.documento}>
                {tercero.nombre} - {tercero.documento}
              </option>
            ))}
          </select>
        </div>
        <Link to="/home/liquidaciones/add" className="bg-green-500 text-white px-4 py-2 rounded flex items-center">
          <FaPlus className="mr-2" /> Añadir Liquidación
        </Link>
      </div>
      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-4">
        <table className="w-full">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-6 py-3">ID</th>
              <th className="px-6 py-3">Fecha</th>
              <th className="px-6 py-3">Tercero ID</th>
              <th className="px-6 py-3">Concepto</th>
              <th className="px-6 py-3">Importe</th>
              <th className="px-6 py-3">Observaciones</th>
              <th className="px-6 py-3">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((liq) => (
              <tr key={liq.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">{liq.id}</td>
                <td className="px-6 py-4">{liq.fecha}</td>
                <td className="px-6 py-4">{liq.terceroId}</td>
                <td className="px-6 py-4">{liq.concepto}</td>
                <td className="px-6 py-4">{liq.importe} €</td>
                <td className="px-6 py-4">{liq.observaciones}</td>
                <td className="px-6 py-4 flex space-x-2">
                  <Link to={`/home/liquidaciones/${liq.id}`} className="text-blue-600 hover:text-blue-900"><FaEye /></Link>
                  <Link to={`/home/liquidaciones/edit/${liq.id}`} className="text-green-600 hover:text-green-900"><FaEdit /></Link>
                  <button onClick={() => handlePrint(liq.id)} className="text-gray-600 hover:text-gray-900"><FaPrint /></button>
                  <button onClick={() => handleDelete(liq.id)} className="text-red-600 hover:text-red-900"><FaTrash /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex justify-center items-center mt-4 space-x-2">
        {[...Array(totalPages).keys()].map(number => (
          <button 
            key={number + 1}
            onClick={() => setCurrentPage(number + 1)}
            className={`px-4 py-2 rounded ${currentPage === number + 1 ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
          >
            {number + 1}
          </button>
        ))}
      </div>
      </div>
    </div>
  );
}

*/



/* CORRECTO SIN VENTANA DE TERCEROS

import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPrint, FaChevronLeft, FaChevronRight, FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function LiquidacionesTable() {
  const [liquidaciones, setLiquidaciones] = useState([]);
  const [filteredLiquidaciones, setFilteredLiquidaciones] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchTercero, setSearchTercero] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchLiquidaciones();
  }, []);

  useEffect(() => {
    filterLiquidaciones();
  }, [searchTerm, searchTercero, liquidaciones]);

  const fetchLiquidaciones = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/liquidaciones');
      setLiquidaciones(response.data);
    } catch (err) {
      setError('Error al cargar las liquidaciones. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const filterLiquidaciones = () => {
    let filtered = liquidaciones.filter(liq =>
      liq.concepto.toLowerCase().includes(searchTerm.toLowerCase()) &&
      liq.terceroId.toLowerCase().includes(searchTercero.toLowerCase())
    );
    setFilteredLiquidaciones(filtered);
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar esta liquidación?')) {
      setIsLoading(true);
      try {
        await axios.delete(`/liquidaciones/${id}`);
        fetchLiquidaciones();
      } catch (err) {
        setError('Error al eliminar la liquidación. Intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handlePrint = async (id) => {
    try {
      const response = await axios.get(`/liquidaciones/${id}/pdfliquidacion`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Liquidacion_${id}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      alert('Error al generar el PDF de la liquidación.');
    }
  };

  const totalPages = Math.ceil(filteredLiquidaciones.length / itemsPerPage);
  const currentItems = filteredLiquidaciones.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-4 text-center">Gestión de Liquidaciones</h1>
      <div className="flex justify-between mb-4">
        <div className="flex space-x-4">
          <input
            type="text"
            placeholder="Buscar por concepto"
            className="border p-2 rounded w-1/2"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <input
            type="text"
            placeholder="Buscar por Tercero ID"
            className="border p-2 rounded w-1/2"
            value={searchTercero}
            onChange={(e) => setSearchTercero(e.target.value)}
          />
        </div>
        <Link to="/home/liquidaciones/add" className="bg-green-500 text-white px-4 py-2 rounded flex items-center">
          <FaPlus className="mr-2" /> Añadir Liquidación
        </Link>
      </div>
      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-4">
        <table className="w-full">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-6 py-3">ID</th>
              <th className="px-6 py-3">Fecha</th>
              <th className="px-6 py-3">Tercero ID</th>
              <th className="px-6 py-3">Concepto</th>
              <th className="px-6 py-3">Importe</th>
              <th className="px-6 py-3">Observaciones</th>
              <th className="px-6 py-3">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((liq) => (
              <tr key={liq.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">{liq.id}</td>
                <td className="px-6 py-4">{liq.fecha}</td>
                <td className="px-6 py-4">{liq.terceroId}</td>
                <td className="px-6 py-4">{liq.concepto}</td>
                <td className="px-6 py-4">{liq.importe} €</td>
                <td className="px-6 py-4">{liq.observaciones}</td>
                <td className="px-6 py-4 flex space-x-2">
                  <Link to={`/home/liquidaciones/${liq.id}`} className="text-blue-600 hover:text-blue-900"><FaEye /></Link>
                  <Link to={`/home/liquidaciones/edit/${liq.id}`} className="text-green-600 hover:text-green-900"><FaEdit /></Link>
                  <button onClick={() => handlePrint(liq.id)} className="text-gray-600 hover:text-gray-900"><FaPrint /></button>
                  <button onClick={() => handleDelete(liq.id)} className="text-red-600 hover:text-red-900"><FaTrash /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex justify-center items-center mt-4 space-x-2">
        <button disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)} className="p-2 bg-gray-200 rounded disabled:opacity-50"><FaChevronLeft /></button>
        {[...Array(totalPages)].map((_, index) => (
          <button key={index + 1} onClick={() => setCurrentPage(index + 1)} className={`p-2 ${currentPage === index + 1 ? 'bg-blue-500 text-white' : 'bg-gray-200'} rounded`}>{index + 1}</button>
        ))}
        <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)} className="p-2 bg-gray-200 rounded disabled:opacity-50"><FaChevronRight /></button>
      </div>
    </div>
  );
}
*/
/* CORRECTO
import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPrint, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function LiquidacionesTable() {
  const [liquidaciones, setLiquidaciones] = useState([]);
  const [filteredLiquidaciones, setFilteredLiquidaciones] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchTercero, setSearchTercero] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchLiquidaciones();
  }, []);

  useEffect(() => {
    filterLiquidaciones();
  }, [searchTerm, searchTercero, liquidaciones]);

  const fetchLiquidaciones = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/liquidaciones');
      setLiquidaciones(response.data);
    } catch (err) {
      setError('Error al cargar las liquidaciones. Intente de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const filterLiquidaciones = () => {
    let filtered = liquidaciones.filter(liq =>
      liq.concepto.toLowerCase().includes(searchTerm.toLowerCase()) &&
      liq.terceroId.toLowerCase().includes(searchTercero.toLowerCase())
    );
    setFilteredLiquidaciones(filtered);
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar esta liquidación?')) {
      setIsLoading(true);
      try {
        await axios.delete(`/liquidaciones/${id}`);
        fetchLiquidaciones();
      } catch (err) {
        setError('Error al eliminar la liquidación. Intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handlePrint = async (id) => {
    try {
      const response = await axios.get(`/liquidaciones/${id}/pdfliquidacion`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Liquidacion_${id}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      alert('Error al generar el PDF de la liquidación.');
    }
  };

  const totalPages = Math.ceil(filteredLiquidaciones.length / itemsPerPage);
  const currentItems = filteredLiquidaciones.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-4 text-center">Gestión de Liquidaciones</h1>
      <div className="flex mb-4 space-x-4">
        <input
          type="text"
          placeholder="Buscar por concepto"
          className="border p-2 rounded w-1/2"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <input
          type="text"
          placeholder="Buscar por Tercero ID"
          className="border p-2 rounded w-1/2"
          value={searchTercero}
          onChange={(e) => setSearchTercero(e.target.value)}
        />
      </div>
      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-4">
        <table className="w-full">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-6 py-3">ID</th>
              <th className="px-6 py-3">Fecha</th>
              <th className="px-6 py-3">Tercero ID</th>
              <th className="px-6 py-3">Concepto</th>
              <th className="px-6 py-3">Importe</th>
              <th className="px-6 py-3">Observaciones</th>
              <th className="px-6 py-3">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((liq) => (
              <tr key={liq.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">{liq.id}</td>
                <td className="px-6 py-4">{liq.fecha}</td>
                <td className="px-6 py-4">{liq.terceroId}</td>
                <td className="px-6 py-4">{liq.concepto}</td>
                <td className="px-6 py-4">{liq.importe} €</td>
                <td className="px-6 py-4">{liq.observaciones}</td>
                <td className="px-6 py-4 flex space-x-2">
                  <Link to={`/home/liquidaciones/${liq.id}`} className="text-blue-600 hover:text-blue-900"><FaEye /></Link>
                  <Link to={`/home/liquidaciones/edit/${liq.id}`} className="text-green-600 hover:text-green-900"><FaEdit /></Link>
                  <button onClick={() => handlePrint(liq.id)} className="text-gray-600 hover:text-gray-900"><FaPrint /></button>
                  <button onClick={() => handleDelete(liq.id)} className="text-red-600 hover:text-red-900"><FaTrash /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex justify-center items-center mt-4 space-x-2">
        <button disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)} className="p-2 bg-gray-200 rounded disabled:opacity-50"><FaChevronLeft /></button>
        {[...Array(totalPages)].map((_, index) => (
          <button key={index + 1} onClick={() => setCurrentPage(index + 1)} className={`p-2 ${currentPage === index + 1 ? 'bg-blue-500 text-white' : 'bg-gray-200'} rounded`}>{index + 1}</button>
        ))}
        <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)} className="p-2 bg-gray-200 rounded disabled:opacity-50"><FaChevronRight /></button>
      </div>
    </div>
  );
}
*/



/*
import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPlus, FaSearch, FaSortAmountDown, FaSortAmountUp, FaPrint } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function LiquidacionesTable() {
  const [liquidaciones, setLiquidaciones] = useState([]);
  const [filteredLiquidaciones, setFilteredLiquidaciones] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchTercero, setSearchTercero] = useState('');
  const [sortColumn, setSortColumn] = useState('id');
  const [sortDirection, setSortDirection] = useState('desc');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchLiquidaciones();
  }, []);

  useEffect(() => {
    filterAndSortLiquidaciones();
  }, [searchTerm, searchTercero, liquidaciones, sortColumn, sortDirection]);

  const fetchLiquidaciones = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/liquidaciones');
      setLiquidaciones(response.data);
      setFilteredLiquidaciones(response.data);
    } catch (err) {
      setError('Error al cargar las liquidaciones. Intente de nuevo.');
      console.error('Error fetching liquidaciones:', err);
    } finally {
      setIsLoading(false);
    }
  };
  const filterAndSortLiquidaciones = () => {
    let filtered = liquidaciones.filter(liq =>
      liq.concepto.toLowerCase().includes(searchTerm.toLowerCase()) &&
      liq.terceroId.toLowerCase().includes(searchTercero.toLowerCase())
    );

    const sorted = filtered.sort((a, b) => {
      if (a[sortColumn] < b[sortColumn]) return sortDirection === 'asc' ? -1 : 1;
      if (a[sortColumn] > b[sortColumn]) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    setFilteredLiquidaciones(sorted);
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar esta liquidación?')) {
      setIsLoading(true);
      setError(null);
      try {
        await axios.delete(`/liquidaciones/${id}`);
        fetchLiquidaciones();
      } catch (err) {
        setError('Error al eliminar la liquidación. Intente de nuevo.');
        console.error('Error deleting liquidación:', err);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handlePrint = async (id) => {
    try {
      const response = await axios.get(`/liquidaciones/${id}/pdfliquidacion`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Liquidacion_${id}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error('Error al imprimir la liquidación:', err);
      alert('Error al generar el PDF de la liquidación.');
    }
  };

  const totalPages = Math.ceil(filteredLiquidaciones.length / itemsPerPage);
const currentItems = filteredLiquidaciones.slice(
  (currentPage - 1) * itemsPerPage,
  currentPage * itemsPerPage
);

return (
  <div className="container mx-auto px-4 py-8">
    <h1 className="text-4xl font-bold mb-8 text-center">
      Gestión de Liquidaciones
    </h1>
    <div className="bg-white shadow-md rounded-lg overflow-hidden mb-8">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-6 py-3">ID</th>
              <th className="px-6 py-3">Fecha</th>
              <th className="px-6 py-3">Tercero ID</th>
              <th className="px-6 py-3">Concepto</th>
              <th className="px-6 py-3">Importe</th>
              <th className="px-6 py-3">Observaciones</th>
              <th className="px-6 py-3">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((liq) => (
              <tr key={liq.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">{liq.id}</td>
                <td className="px-6 py-4">{liq.fecha}</td>
                <td className="px-6 py-4">{liq.terceroId}</td>
                <td className="px-6 py-4">{liq.concepto}</td>
                <td className="px-6 py-4">{liq.importe} €</td>
                <td className="px-6 py-4">{liq.observaciones}</td>
                <td className="px-6 py-4 flex space-x-2">
                  <Link
                    to={`/home/liquidaciones/${liq.id}`}
                    className="text-blue-600 hover:text-blue-900"
                  >
                    <FaEye />
                  </Link>
                  <Link
                    to={`/home/liquidaciones/edit/${liq.id}`}
                    className="text-green-600 hover:text-green-900"
                  >
                    <FaEdit />
                  </Link>
                  <button
                    onClick={() => handlePrint(liq.id)}
                    className="text-gray-600 hover:text-gray-900"
                  >
                    <FaPrint />
                  </button>
                  <button
                    onClick={() => handleDelete(liq.id)}
                    className="text-red-600 hover:text-red-900"
                  >
                    <FaTrash />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);
}
*/
  /*
  const totalPages = Math.ceil(filteredLiquidaciones.length / itemsPerPage);
  const currentItems = filteredLiquidaciones.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-8 text-center">Gestión de Liquidaciones</h1>
      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-8">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3">ID</th>
                <th className="px-6 py-3">Fecha</th>
                <th className="px-6 py-3">Tercero ID</th>
                <th className="px-6 py-3">Concepto</th>
                <th className="px-6 py-3">Importe</th>
                <th className="px-6 py-3">Observaciones</th>
                <th className="px-6 py-3">Acciones</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {currentItems.map((liq) => (
                <tr key={liq.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4">{liq.id}</td>
                  <td className="px-6 py-4">{liq.fecha}</td>
                  <td className="px-6 py-4">{liq.terceroId}</td>
                  <td className="px-6 py-4">{liq.concepto}</td>
                  <td className="px-6 py-4">{liq.importe} €</td>
                  <td className="px-6 py-4">{liq.observaciones}</td>
                  <td className="px-6 py-4 flex space-x-2">
                    <Link to={`/home/liquidaciones/${liq.id}`} className="text-blue-600 hover:text-blue-900"><FaEye /></Link>
                    <Link to={`/home/liquidaciones/edit/${liq.id}`} className="text-green-600 hover:text-green-900"><FaEdit /></Link>
                    <button onClick={() => handlePrint(liq.id)} className="text-gray-600 hover:text-gray-900"><FaPrint /></button>
                    <button onClick={() => handleDelete(liq.id)} className="text-red-600 hover:text-red-900"><FaTrash /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

*/